module.exports = __webpack_public_path__ + "img/27.8531ade1.webp";